import { render, staticRenderFns } from "./QBR.vue?vue&type=template&id=3b2fcd6c"
import script from "./QBR.vue?vue&type=script&lang=js"
export * from "./QBR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b2fcd6c')) {
      api.createRecord('3b2fcd6c', component.options)
    } else {
      api.reload('3b2fcd6c', component.options)
    }
    module.hot.accept("./QBR.vue?vue&type=template&id=3b2fcd6c", function () {
      api.rerender('3b2fcd6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/OtherTargetMaintain/QBR.vue"
export default component.exports